<template>
	<a-modal
		:title="isUpdate ? '修改' : '新增'"
		:width="720"
		:visible="visible"
		:footer="null"
		:maskClosable="false"
		@cancel="handleCancel"
	>
		<a-spin :spinning="loading">
			<a-form-model
				ref="adminForm"
				:model="form"
				:label-col="{ span: 5 }"
				:wrapper-col="{ span: 17 }"
				auto-complete="off"
			>
				<a-form-model-item v-show="false" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>

				<a-form-model-item label="手机系统" prop="phoneOs" :rules="rules.requiredSelect">
					<a-select v-model="form.phoneOs" placeholder="请选择" allow-clear style="width: 100%">
						<a-select-option value="ANDROID">安卓</a-select-option>
						<a-select-option value="IOS">iOS</a-select-option>
						<a-select-option value="HARMONY">鸿蒙</a-select-option>
						<a-select-option value="UNLIMIT">不限</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="商品类型" prop="type" :rules="rules.requiredSelect">
					<a-select v-model="form.type" placeholder="请选择" allow-clear style="width: 100%" @change="onTypeChange">
						<a-select-option v-for="o in typeOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="名称" prop="name" :rules="rules.name">
					<a-input v-model="form.name" placeholder="名称" />
				</a-form-model-item>

				<a-form-model-item label="货币" prop="currency" :rules="rules.requiredSelect">
					<a-select
						v-model="form.currency"
						placeholder="请先选择商品类型"
						:disabled="!!form.type"
						allow-clear
						style="width: 100%"
					>
						<a-select-option value="CNY">人民币</a-select-option>
						<a-select-option value="SCORE">积分</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="价格" prop="price" :rules="rules.price">
					<a-input v-model="form.price" placeholder="价格" style="width: 200px" />
				</a-form-model-item>

				<a-form-model-item label="摘要" prop="digest">
					<a-textarea v-model="form.digest" placeholder="摘要" :rows="3" />
				</a-form-model-item>

				<a-form-model-item label="描述" prop="depict">
					<a-textarea v-model="form.depict" placeholder="描述" :rows="3" />
				</a-form-model-item>

				<template v-if="showTransferGroup">
					<a-row :gutter="16">
						<a-col :span="12">
							<a-form-model-item
								label="转账金额"
								prop="transferAmountYuan"
								:label-col="{ span: 10 }"
								:wrapper-col="{ span: 14 }"
								:rules="rules.amountYuan"
							>
								<a-input v-model="form.transferAmountYuan" placeholder="0" addon-after="元" />
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item
								label="手续费"
								prop="transferFeeYuan"
								:label-col="{ span: 10 }"
								:wrapper-col="{ span: 14 }"
								:rules="rules.amountYuan"
							>
								<a-input v-model="form.transferFeeYuan" placeholder="0" addon-after="元" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</template>

				<template v-if="showGoldGroup">
					<a-form-model-item label="金币数量" prop="goldNum" :rules="rules.positiveInt">
						<a-input v-model="form.goldNum" placeholder="0" addon-after="枚" style="max-width: 280px" />
					</a-form-model-item>
				</template>

				<template v-if="showVipGroup">
					<a-form-model-item label="时长" prop="vipDays" :rules="rules.positiveInt">
						<a-input v-model="form.vipDays" placeholder="0" addon-after="天" style="max-width: 280px" />
					</a-form-model-item>
					<a-form-model-item
						v-if="showGiftGold"
						label="赠送金币"
						prop="giftGold"
						:rules="rules.nonNegInt"
					>
						<a-input v-model="form.giftGold" placeholder="0" addon-after="枚" style="max-width: 280px" />
					</a-form-model-item>
				</template>

				<a-form-model-item label="限首次" prop="isFirst" :rules="rules.requiredSelect">
					<a-select v-model="form.isFirst" placeholder="请选择" style="width: 200px">
						<a-select-option value="N">否</a-select-option>
						<a-select-option value="Y">是</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="排序" prop="seq" :rules="rules.seq">
					<a-input v-model="form.seq" placeholder="50" style="width: 200px" />
				</a-form-model-item>
			</a-form-model>
			<div class="product-form-footer">
				<a-button type="primary" :loading="loading" @click="submit">提交</a-button>
			</div>
		</a-spin>
	</a-modal>
</template>

<script>
import pick from 'lodash.pick';

const typeOptions = [
	{ value: 'RECHARGE_GOLD', label: '充值金币' },
	{ value: 'RECHARGE_VIP', label: '充值会员' },
	{ value: 'EXCHANGE_GOLD', label: '兑换金币' },
	{ value: 'EXCHANGE_VIP', label: '兑换会员' },
	{ value: 'EXCHANGE_CASH', label: '兑换现金' },
];

const fields = [
	'id',
	'phoneOs',
	'type',
	'currency',
	'price',
	'name',
	'digest',
	'depict',
	'isFirst',
	'seq',
	'transferAmountYuan',
	'transferFeeYuan',
	'goldNum',
	'vipDays',
	'giftGold',
];

function emptyForm() {
	return {
		id: 0,
		phoneOs: undefined,
		type: undefined,
		currency: undefined,
		price: '',
		name: '',
		digest: '',
		depict: '',
		isFirst: 'N',
		seq: '50',
		transferAmountYuan: '',
		transferFeeYuan: '',
		goldNum: '',
		vipDays: '',
		giftGold: '0',
	};
}

export default {
	name: 'ProductForm',
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		model: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			typeOptions,
			form: emptyForm(),
			rules: {
				requiredSelect: [{ required: true, message: '必选', trigger: 'change' }],
				name: [{ required: true, message: '必填', trigger: 'blur' }],
				price: [
					{ required: true, message: '必填', trigger: 'blur' },
					{
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '请输入正确数字（最多两位小数）',
						trigger: 'blur',
					},
				],
				amountYuan: [
					{ required: true, message: '必填', trigger: 'blur' },
					{
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '金额格式不正确',
						trigger: 'blur',
					},
				],
				positiveInt: [
					{ required: true, message: '必填', trigger: 'blur' },
					{ pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' },
				],
				nonNegInt: [
					{ required: true, message: '必填', trigger: 'blur' },
					{ pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' },
				],
				seq: [
					{ required: true, message: '必填', trigger: 'blur' },
					{ pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' },
				],
			},
		};
	},
	computed: {
		isUpdate() {
			return this.model && this.model.id > 0;
		},
		showTransferGroup() {
			return this.form.type === 'EXCHANGE_CASH';
		},
		showGoldGroup() {
			return this.form.type === 'RECHARGE_GOLD' || this.form.type === 'EXCHANGE_GOLD';
		},
		showVipGroup() {
			return this.form.type === 'RECHARGE_VIP' || this.form.type === 'EXCHANGE_VIP';
		},
		/** 仅充值会员展示赠送金币，兑换会员不展示 */
		showGiftGold() {
			return this.form.type === 'RECHARGE_VIP';
		},
	},
	watch: {
		model: {
			handler(newVal) {
				if (!newVal) {
					this.initForm();
					return;
				}
				this.$nextTick(() => {
					const base = pick(newVal, fields);
					const merged = { ...emptyForm(), ...base };
					merged.seq = merged.seq != null && merged.seq !== '' ? String(merged.seq) : '50';
					merged.id = merged.id || 0;
					merged.transferAmountYuan =
						newVal.transferAmountYuan != null && newVal.transferAmountYuan !== ''
							? String(newVal.transferAmountYuan)
							: '';
					merged.transferFeeYuan =
						newVal.transferFeeYuan != null && newVal.transferFeeYuan !== ''
							? String(newVal.transferFeeYuan)
							: '';
					merged.goldNum = newVal.goldNum != null && newVal.goldNum !== '' ? String(newVal.goldNum) : '';
					merged.vipDays = newVal.vipDays != null && newVal.vipDays !== '' ? String(newVal.vipDays) : '';
					merged.giftGold =
						newVal.giftGold != null && newVal.giftGold !== '' ? String(newVal.giftGold) : '0';
					merged.price = newVal.price != null && newVal.price !== '' ? String(newVal.price) : '';
					this.form = merged;
					this.syncCurrencyByType(this.form.type);
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			immediate: true,
		},
	},
	methods: {
		/** 充值类 → 人民币；兑换类 → 积分 */
		syncCurrencyByType(type) {
			if (!type) {
				return;
			}
			if (type.indexOf('RECHARGE') === 0) {
				this.form.currency = 'CNY';
			} else if (type.indexOf('EXCHANGE') === 0) {
				this.form.currency = 'SCORE';
			}
		},
		initForm() {
			this.form = emptyForm();
			this.$nextTick(() => {
				if (this.$refs.adminForm) {
					this.$refs.adminForm.clearValidate();
				}
			});
		},
		onTypeChange() {
			if (!this.form.type) {
				this.form.currency = undefined;
			} else {
				this.syncCurrencyByType(this.form.type);
			}
			if (!this.showTransferGroup) {
				this.form.transferAmountYuan = '';
				this.form.transferFeeYuan = '';
			}
			if (!this.showGoldGroup) {
				this.form.goldNum = '';
			}
			if (!this.showVipGroup) {
				this.form.vipDays = '';
				this.form.giftGold = '0';
			} else if (!this.showGiftGold) {
				this.form.giftGold = '0';
			} else if (this.form.giftGold === '' || this.form.giftGold === null) {
				this.form.giftGold = '0';
			}
		},
		handleCancel() {
			this.$emit('cancel');
		},
		submit() {
			this.$refs.adminForm.validate((valid) => {
				if (!valid) return;
				this.$emit('ok');
			});
		},
		getFormPayload() {
			return { ...this.form };
		},
	},
};
</script>

<style lang="less" scoped>
.product-form-footer {
	text-align: center;
	margin-top: 16px;
	padding-top: 12px;
	border-top: 1px solid #f0f0f0;
}
</style>
